export const compareByDepth = (a, b) => a.depth - b.depth;
//# sourceMappingURL=compare-by-depth.js.map